import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Ridgeline } from "@/components/common/Ridgeline";
import { Wordmark } from "@/components/common/Wordmark";
import { usePrefersReducedMotion } from "@/hooks/useReducedMotion";

// First-load moment: pine screen, wordmark, a ridgeline drawing itself in.
// Skipped on the home route ("/") because the Hero's cinematic door reveal
// is now the loading moment for the homepage — running both would layer
// the Loader on top of the door animation and hide it entirely.
export const Loader = () => {
  const reduced = usePrefersReducedMotion();
  const [done, setDone] = useState(false);

  // Check pathname at mount time (Loader runs once on first paint).
  const skip =
    typeof window !== "undefined" && window.location.pathname === "/";

  useEffect(() => {
    if (skip) {
      setDone(true);
      return;
    }
    const t = setTimeout(() => setDone(true), reduced ? 500 : 1900);
    return () => clearTimeout(t);
  }, [reduced, skip]);

  if (skip) return null;

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="grain fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden"
          style={{ backgroundColor: "#14231B" }}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }}
          data-testid="loader"
        >
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="relative z-10"
          >
            <Wordmark
              asLink={false}
              color="#EDE9E0"
              goldColor="#E3B268"
              size="text-4xl"
              showSub
              subColor="#AEC4C7"
            />
          </motion.div>

          <div className="relative z-10 mt-10 w-[min(560px,72vw)]">
            <Ridgeline stroke="#C89A4E" animate height={90} />
          </div>

          <motion.p
            className="eyebrow relative z-10 mt-6"
            style={{ color: "#AEC4C7" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.8 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            Finding your way home
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
